/* 热门资讯 */
import React, { useState, useEffect } from 'react'

import { IFeedData } from 'lib/fetch-feed'

import Feed from 'Components/feed-new-series'
import Tab from './common/tab'
import { sendTeaCommEvent } from 'lib/tea-analyze'

interface IProps {
  seriesId: number
}

const conditions = ['all', 'all', 'pingche']
const subCategory = ['', 'video', '']

export default function PopularContent({ seriesId }: IProps) {
  const [curIndex, setCurIndex] = useState(0)
  const [list, setList] = useState<IFeedData[]>([])

  return (
    <section id="hot-feed">
      <Tab
        curIndex={curIndex}
        setCurIndex={setCurIndex}
        setList={setList}
        leftContent="热门资讯"
        rightContent={['综合', '视频', '实测']}
        onClick={index => {
          sendTeaCommEvent('click_series_picture_list_tab', {
            car_series_id: seriesId,
            sub_tab: conditions[index],
          })
        }}
      />
      <div>
        <Feed
          category={conditions[curIndex]}
          subCategory={subCategory[curIndex]}
          page="series_home"
          concern_id={seriesId}
          onClick={(group_id: string | number, content_type: number) => {
            sendTeaCommEvent('click_series_hot_news', {
              car_series_id: seriesId,
              group_id,
              sub_tab: conditions[curIndex],
              content_type,
            })
          }}
        />
      </div>
      <style jsx>
        {`
          section {
            width: 868px;
            background: #ffffff;
            border-radius: 2px;
            margin-top: 8px;
            margin-bottom: 160px;
          }
          div {
            padding: 0 16px;
          }
        `}
      </style>
    </section>
  )
}
